/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AppointmentCriteriaFieldV1 {
    APPOINTMENT_ID = 'APPOINTMENT_ID',
    TITLE = 'TITLE',
    TYPE = 'TYPE',
    STATUS = 'STATUS',
    START_DATE = 'START_DATE',
    START_TIMESTAMP = 'START_TIMESTAMP',
    END_TIMESTAMP = 'END_TIMESTAMP',
    EVENT_ID = 'EVENT_ID',
    PARTICIPANT_USER_ID = 'PARTICIPANT_USER_ID',
    META_TYPE = 'META_TYPE',
    META_DATA = 'META_DATA',
    LOCATION_TYPE = 'LOCATION_TYPE',
    LOCATION_REF = 'LOCATION_REF',
    REQUEST_CODE = 'REQUEST_CODE',
    REQUEST_VERSION_CODE = 'REQUEST_VERSION_CODE',
    REQUEST_SCHEDULE_CODE = 'REQUEST_SCHEDULE_CODE',
    REQUEST_REPEAT_INDEX = 'REQUEST_REPEAT_INDEX',
    REQUEST_WINDOW_START = 'REQUEST_WINDOW_START',
    REQUEST_WINDOW_END = 'REQUEST_WINDOW_END',
    CUSTOM_STATUS_TYPE = 'CUSTOM_STATUS_TYPE',
    CUSTOM_STATUS_VALUE = 'CUSTOM_STATUS_VALUE',
    REFS_KEY = 'REFS_KEY',
    REFS_VALUE = 'REFS_VALUE',
}